import { memo, useRef, useMemo, useEffect } from 'react';
import type { ApngPlayerProps, ApngPlayerRef } from '../ApngPlayer';
import { ApngPlayer } from '../ApngPlayer';

export interface AvatarBgProps extends ApngPlayerProps {
  disabled?: boolean;
  play?: boolean;
  size?: string;
  children: React.ReactNode;
}

export const AvatarBg = memo(function AvatarBg({
  children,
  disabled = false,
  play = false,
  size = 'sm',
  ...props
}: AvatarBgProps) {
  const apngPlayerRef = useRef<ApngPlayerRef>(null);

  const apngSizeMap = useMemo(
    () => ({
      xs: (32 / 120) * 168,
      sm: (36 / 120) * 168,
      md: (40 / 120) * 168,
      lg: (44 / 120) * 168,
      xl: (48 / 120) * 168,
      '2xl': (64 / 120) * 168,
      '3xl': (88 / 120) * 168,
    }),
    []
  );

  useEffect(() => {
    if (apngPlayerRef.current?.player) {
      if (play) {
        apngPlayerRef.current.player.play();
      } else {
        apngPlayerRef.current.player.pause();
      }
    }
  }, [play]);

  if (disabled) {
    return children;
  }

  return (
    <ApngPlayer
      ref={apngPlayerRef}
      style={{
        width: apngSizeMap[(size as keyof typeof apngSizeMap) ?? 'sm'],
        height: apngSizeMap[(size as keyof typeof apngSizeMap) ?? 'sm'],
      }}
      width={168}
      height={168}
      autoPlay={false}
      {...props}
    >
      {children}
    </ApngPlayer>
  );
});
